import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

const RouteContext = createContext({ path: '/', navigate: () => {} });

export function useRoute() {
  return useContext(RouteContext);
}

export function normalizePath(p) {
  if (!p) return '/';
  if (p !== '/' && !p.endsWith('/')) return p + '/';
  return p;
}

export function Router({ initialPath, children }) {
  const [path, setPath] = useState(() =>
    initialPath !== undefined
      ? initialPath
      : typeof window !== 'undefined'
        ? normalizePath(window.location.pathname)
        : '/'
  );

  useEffect(() => {
    const onPop = () => setPath(normalizePath(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const navigate = useCallback((to) => {
    const target = normalizePath(to);
    if (typeof window !== 'undefined') {
      if (target !== window.location.pathname) {
        window.history.pushState({}, '', target);
      }
      window.scrollTo(0, 0);
    }
    setPath(target);
  }, []);

  return (
    <RouteContext.Provider value={{ path, navigate }}>
      {children}
    </RouteContext.Provider>
  );
}

export function Link({ to, children, onClick, ...rest }) {
  const { navigate } = useRoute();
  return (
    <a
      href={to}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || rest.target === '_blank') return;
        e.preventDefault();
        navigate(to);
        if (onClick) onClick(e);
      }}
      {...rest}
    >
      {children}
    </a>
  );
}
